import React from 'react'; // Убедитесь, что React импортирован
import extendedButton from '../../../../../../assets/icons/extendedButton.svg';
import cls from './ExtendedButton.module.scss';

interface ExtendedButtonProps {
	collapsed: any;
	setCollapsed: (collapsed: boolean) => void;
}

const ExtendedButton = ({ collapsed, setCollapsed }: ExtendedButtonProps) => {
	const onToggle = () => {
		// @ts-ignore
		setCollapsed((prev) => !prev);
		console.log('onToggle');
		console.log(collapsed);
	};
	
	return (
		<button
			className={cls.button}
			onClick={onToggle}
		>
			<img src={extendedButton} alt='extendedButton' />
		</button>
	);
};

export default ExtendedButton;
